import { createSelector } from 'reselect';
import { values } from 'lodash';
import { combineReducers } from 'redux';

import { LOCATION_CHANGE } from './../actions';
import {
  CHANGE_INSTALLER_FILE,
  SELECT_ALL_INSTALLER_FILES,
  SET_SELECTED_INSTALLER_FILES_AS_EXPECTED
} from '../actions/installerFiles';
import { fetchInstallerDifferencesActionTypes } from './../actions/types';

const initialState = {
  inProgress: false,
  args: undefined
};

const request = (state = initialState, action) => {
  switch (action.type) {
    case fetchInstallerDifferencesActionTypes.request:
      return {
        inProgress: true,
        args: {
          ...state.args,
          [action.args[0]]: [
            ...((state.args && state.args[action.args[0]]) || []),
            action.args[1]
          ]
        }
      };
    case LOCATION_CHANGE:
      return initialState;
    default:
      return state;
  }
};

const mutateFiles = (state, files, mutator) => {
  const changes = files.reduce((result, f) => {
    result[f.id] = {
      ...f,
      ...mutator(f)
    };
    return result;
  }, {});
  return {
    ...state,
    ...changes
  };
};

const byId = (state = {}, action) => {
  switch (action.type) {
    case fetchInstallerDifferencesActionTypes.success:
      return {
        ...state,
        ...action.response
      };
    case CHANGE_INSTALLER_FILE:
      return {
        ...state,
        [action.file.id]: action.file
      };
    case SELECT_ALL_INSTALLER_FILES:
      return mutateFiles(state, action.files, () => ({ selected: action.selected }));
    case SET_SELECTED_INSTALLER_FILES_AS_EXPECTED:
      return mutateFiles(state, action.files, f => {
        if (!f.selected) {
          return {};
        }

        return { expected: action.expected };
      });
    case LOCATION_CHANGE:
      return {};
    default:
      return state;
  }
};

const installerDifferences = combineReducers({
  request,
  byId
});

export default installerDifferences;

const installerDifferencesState = state => state.installerDifferences.byId;
export const getFileById = (state, id) => installerDifferencesState(state)[id];

export const installerDifferencesByBuildIds = createSelector(
  installerDifferencesState,
  (fillesById) => values(fillesById).reduce((result, file) => {
    const byBaseline = [
      ...((result[file.buildId] && result[file.buildId][file.baselineBuildId]) || []),
      file
    ];

    result[file.buildId] = {
      ...(result[file.buildId] || {}),
      [file.baselineBuildId]: byBaseline
    };
    return result;
  }, {})
);


export const getInstallerDifferenceByBuildsIds = (state, buildId, baselineBuildId) => {
  const byBuildId = installerDifferencesByBuildIds(state)[buildId];
  if (!byBuildId) {
    return undefined;
  }

  return byBuildId[baselineBuildId];
};


// WEBPACK FOOTER //
// src/reducers/installerDifferences.js